/* DeSiM 公式店 — 国家集合ページ（sections/main-collection.liquid）専用 JS。

   プラン種別タブ（∞完全無制限 / 日次リセット / 容量指定）は**絞り込み**。

   🔴 2026-09-08 運営レビュー: 以前の実装はタブを押しても「その種類の最初のカードへ
      スクロールする」だけで、一覧の中身は一切変わらなかった。設計上そういう意図
      （常に全カードが同時に見えている構成）だったが、押しても表示が同じに見えるため
      「無制限・日次リセット・容量指定どれを選んでも同じ内容になる」という指摘に
      なった。タブが選択肢の見た目をしている以上、実際に絞る方が期待に合う。

   判定はカードの `data-plan-kinds`（Liquid 側で付ける、空白区切り）。ラベル文字列
   での照合はしない（文言を変えた瞬間に黙って壊れるため）。

   🔴 2026-09-26 運営指摘: 商品ページの「この国に行く方はこちらも」から
      「中国・香港・マカオ・台湾」（容量指定の商品 1 件だけ）へ飛ぶと、既定の
      「完全無制限」タブがその 1 件を隠し、「プランがまだありません」だけが出た。
      利用者には商品が無いように見え、次に何をすればよいか分からない。
      → 該当 0 件のタブは出さない。既定タブが 0 件なら商品のある最初のタブで始める。
        種類が 1 つしか無ければ選ぶ物が無いのでタブ列ごと隠す。 */
(function () {
  var tabsWrap = document.querySelector('[data-ds-plan-tabs]');
  var list = document.querySelector('.ds-plan-list');
  if (!tabsWrap || !list) return;

  var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-plan-kind]'));
  var cards = Array.prototype.slice.call(list.querySelectorAll('[data-plan-kinds]'));
  if (!tabs.length || !cards.length) return;

  /* 画面文言は main-collection.liquid の <script type="application/json" data-ds-i18n="shop">
     から読む（locale の shop.collection.no_plans_for_kind。%KIND% をタブ名に置き換える）。 */
  var i18n = {};
  try {
    var i18nEl = document.querySelector('script[data-ds-i18n="shop"]');
    if (i18nEl) i18n = JSON.parse(i18nEl.textContent) || {};
  } catch (e) {
    i18n = {};
  }

  /** 「このタブに該当するカードが無い」ときに出す行。初回に 1 つだけ作る。 */
  var empty = document.createElement('p');
  empty.className = 'ds-section__note ds-plan-list__empty';
  empty.hidden = true;
  list.parentNode.insertBefore(empty, list.nextSibling);

  function kindsOf(card) {
    return (card.getAttribute('data-plan-kinds') || '').split(/\s+/);
  }

  function apply(kind, label) {
    var shown = 0;
    cards.forEach(function (card) {
      var hit = kindsOf(card).indexOf(kind) !== -1;
      card.hidden = !hit;
      if (hit) shown++;
    });
    if (shown === 0) {
      empty.textContent = String(i18n.no_plans_for_kind || '').replace('%KIND%', label);
      empty.hidden = false;
    } else {
      empty.hidden = true;
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-pressed', 'true');
      apply(tab.getAttribute('data-plan-kind'), (tab.textContent || '').trim());
    });
  });

  // 🔴 タブ列もタブも CSS で display を指定しているので `hidden` 属性では消えない
  //    （カードには `.ds-plan-card[hidden]` の規則があるがタブには無い）。style で消す。
  function hide(el) {
    el.style.display = 'none';
  }

  // 該当カードが 0 件のタブは出さない（押しても「ありません」しか出ない選択肢は迷わせるだけ）。
  var available = tabs.filter(function (t) {
    var kind = t.getAttribute('data-plan-kind');
    var has = cards.some(function (card) {
      return kindsOf(card).indexOf(kind) !== -1;
    });
    if (!has) hide(t);
    return has;
  });
  // どのタブにも当たらないカードしか無い（種類の判定漏れ）なら、絞り込まずに全部見せる。
  if (!available.length) {
    hide(tabsWrap);
    return;
  }
  // 種類が 1 つだけなら選ぶ物が無いのでタブ列ごと隠し、全カードを見せる。
  if (available.length === 1) hide(tabsWrap);

  // 初期表示はマークアップ側で `is-active` が付いているタブ。それが 0 件なら商品のある最初のタブ。
  // 🔴 JS 無効時は全カードが見えるだけ（hidden を付けるのはこの JS なので、
  //    絞り込みが動かない環境で商品が消えることはない）。
  var initial =
    available.filter(function (t) {
      return t.classList.contains('is-active');
    })[0] || available[0];
  tabs.forEach(function (t) {
    var on = t === initial;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  apply(initial.getAttribute('data-plan-kind'), (initial.textContent || '').trim());
})();
